export class ConfigOnly {

    width = 1
    height = ''
    type = 'desktop'
    documentType = 'word'
    title = 'Documento Focus'
    url = ""   
    fileType = 'docx'
    key = 'cacca12a3250a62c1859'
    author = ''
    created = ''
    mode = 'edit'   
    callbackUrl = ''   
    id = '2'
    hideRightMenu = false
    hideRulers = false
    name = ''
    container = 'texto'
    uiTheme = 'theme-light'
    edit = true
    zoom = 180
    toolbarNoTabs = true
    toolbarHideFileName = true
    compactHeader = true
    compactToolbar = true
    mobile: any = null
    mobileForceView: any = null
    toolbar = false
    statusBar = false
    logo = {
    image : "https://demo.focusts.com.br/assets/images/logos/focus.png",
    imageDark : "https://demo.focusts.com.br/assets/images/logos/focus.png",
    url : ""
    } 

}

export class LogoOnlyoffice {
    
    image = "https://demo.focusts.com.br/assets/images/logos/focus.png"
    imageDark = "https://demo.focusts.com.br/assets/images/logos/focus.png"
    url = ""
    
}
